import { supabase } from '../config/supabase';

export const SETTINGS_KEYS = {
    OPPORTUNITY_CHECKLISTS: 'opportunity_checklists'
};

export const settingsService = {
    /**
     * Get a setting by key
     * @param {string} key 
     * @returns {Promise<{success: boolean, data: any, error?: any}>}
     */
    async getSettings(key) {
        try {
            const { data, error } = await supabase
                .from('system_settings')
                .select('setting_value')
                .eq('setting_key', key)
                .single();

            if (error) throw error;
            return { success: true, data: data.setting_value };
        } catch (error) {
            console.error(`Error fetching settings for key ${key}:`, error);
            return { success: false, error };
        }
    },

    /**
     * Update a setting by key
     * @param {string} key 
     * @param {any} value 
     * @returns {Promise<{success: boolean, data: any, error?: any}>}
     */
    async updateSettings(key, value) {
        try {
            const { data: { user } } = await supabase.auth.getUser();

            const { data, error } = await supabase
                .from('system_settings')
                .upsert({
                    key,
                    value,
                    updated_at: new Date().toISOString(),
                    updated_by: user?.id
                })
                .select()
                .single();

            if (error) throw error;
            return { success: true, data };
        } catch (error) {
            console.error(`Error updating settings for key ${key}:`, error);
            return { success: false, error };
        }
    }
};
